import User from "./user";

export const PermissionsHelper = {
  hasUserAtLeastRole: (role: string, user: User | null | undefined, objectWithRoles: { roles?: Record<string, string[]>} | undefined): boolean => {
    const acceptedRoles: string[] = [];
    
    if(role.startsWith("sectionManager_")) {
      acceptedRoles.push('superAdmin');
      acceptedRoles.push('organisationManager');
      acceptedRoles.push('plantManager');
      acceptedRoles.push('projectManager');
    }
    if(role === "projectManager") {
      acceptedRoles.push('superAdmin');
      acceptedRoles.push('organisationManager');
      acceptedRoles.push('plantManager');
    }
    if(role === "plantManager") {
      acceptedRoles.push('superAdmin');
      acceptedRoles.push('organisationManager');
    }

    if(role === "organisationManager") {
      acceptedRoles.push('superAdmin');
    }
    
    acceptedRoles.push(role);
    
    return user != null && objectWithRoles != null &&
    (user.roles?.some((r) => acceptedRoles.indexOf(r) !== -1) ||
      objectWithRoles.roles?.[user.email].some((r) => {
        return (
          acceptedRoles.indexOf(r) !== -1
        );
      })) === true;
  },
};